
import { defineComponent, computed, reactive,ref, toRefs, onBeforeUnmount, getCurrentInstance, nextTick, onMounted, watch } from 'vue'
import { useStore } from '@/store/index'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'
import { useRoute, useRouter } from 'vue-router'
import { getMenuWarningApi } from '@/apis/zone'
import { getInstationMsgWarnApi } from '@/apis/notice'
import { getUnResolveOrder } from '../../../apis/order'
import { getUnResolveWorkorderApi, getWorkorderCheckStatusApi } from '../../../apis/workorder'
import { Fold,ArrowLeft } from '@element-plus/icons-vue'
import { UserType } from '../../../enums/user'
import { turnonSpeech } from '../../../utils/speech-tts'
import BindWxDialog from '../../../components/BindWxDialog.vue'
import BindPhoneDialog from '../../../components/BindPhoneDialog.vue'
import NoticeDialog from '../../../components/NoticeDialog.vue'
import { Bell } from '@element-plus/icons-vue'
import ActivityEdit from '@/views/merchant-admin/ActivityEdit.vue'
import { ElNotification, ElMessageBox } from 'element-plus'
import NoticeList from '@/views/notice/NoticeList.vue'
import { Search } from '@element-plus/icons-vue'

export default defineComponent({
    components: { Fold, BindWxDialog, BindPhoneDialog,NoticeDialog,ArrowLeft,Bell,ElNotification,Search },
    setup() {
        const store = useStore()
        const route = useRoute()
        const router = useRouter()
        const { proxy } = getCurrentInstance() as any
        // const expressMsg = computed(() => store.state.user.expressMsg || []);
        const expressMsg = JSON.parse(localStorage.getItem('expressMsg') || '[]');
        const promotionMsg = store.state.user.promotionMsg
        const sidebar = computed(() => {
            return store.state.app.sidebar
        })
        const userInfo = computed(() => {
            return store.state.user.userInfo
        })
        const state = reactive({
            phoneDialog: false,
            ActivityDialog: true,
            // speech: null, // 语音播报
            toggleSideBar: () => {
                store.dispatch(AppActionTypes.ACTION_TOGGLE_SIDEBAR, false)
            },
            NoticeList:[]
        })

        // 搜索相关
        const searchDialogVisible = ref(false)
        const searchQuery = ref('')
        const searchResults = ref([])

        // 打开搜索弹窗
        const openSearchDialog = () => {
            searchDialogVisible.value = true
            // 清空搜索状态
            searchQuery.value = ''
            searchResults.value = []
        }

        // 搜索弹窗打开时聚焦输入框
        const onSearchDialogOpen = () => {
            setTimeout(() => {
                const inputEl = document.querySelector('#search-nav-input')
                if (inputEl) {
                    inputEl.focus()
                }
            }, 100)
        }

        // 搜索处理
        const handleSearch = () => {
            if (!searchQuery.value) {
                searchResults.value = []
                return
            }
            searchResults.value = searchRoutes(store.state.permission.routes, searchQuery.value)
        }

        // 点击搜索结果
        const handleSearchResultClick = (result) => {
            router.push(result.path)
            searchDialogVisible.value = false
            searchQuery.value = ''
            searchResults.value = []
        }

        // 搜索路由
        const searchRoutes = (routes, query) => {
            const results = []
            const lowerQuery = query.toLowerCase()

            const traverseRoutes = (routeList, parentPath = '') => {
                for (const route of routeList) {
                    // 计算完整路径
                    const fullPath = parentPath ? `${parentPath}/${route.path}` : route.path
                    
                    // 只搜索children菜单
                    if (route.children && route.children.length > 0) {
                        traverseRoutes(route.children, fullPath)
                    } else {
                        if (route.meta && route.meta.title && route.meta.hasPermission !== false && route.meta.hidden !== true) {
                            const title = route.meta.title.toString().toLowerCase()
                            if (title.includes(lowerQuery)) {
                                results.push({
                                    path: fullPath,
                                    title: route.meta.title
                                })
                            }
                        }
                    }
                }
            }

            traverseRoutes(routes)
            return results
        }
        const dialogBeforeClose = () => {
            state.ActivityDialog = false
        }
        const warningLength = computed(() => {
            return store.state.user.menuWarning
        })

        const stopWatch = watch(() => store.state.user.menuWarning.instationMsgWarn,(newVal, oldVal) => {
            if (newVal !== oldVal) {
                getInstationMsgWarn();
            }
        },
        { deep: true }
        );
        const promotionDialog = () => {
            const notificationInstance = ElNotification({
                message: `
                    <div class="notification-content promotion-notification">
                        <h4 text-indent: -50px;>
                            <i class="iconfont icon-horn" 
                                style="margin-right:8px; font-size: 28px; color: #ffb538; vertical-align: middle;"></i>
                            ${promotionMsg.name}
                        </h4>
                        <div>
                            <p style="margin-top:5px">报名时间：${promotionMsg.apply_start_at} 至 ${promotionMsg.apply_end_at}</p>
                            <div class="notification-link" style="color: #409EFF;text-align: right;">去报名>></div>
                        </div>
                    </div>
                `,
                duration: 0,
                zIndex: 1500,
                dangerouslyUseHTMLString: true,
                // offset: 300,
            });

            document.addEventListener('click', function handler(event) {
                const target = event.target as HTMLElement;
                const notificationBox = target.closest('.promotion-notification');

                // **确保点击的是 promotionDialog 相关的通知**
                if (!notificationBox) return;

                if (target.classList.contains('notification-link')) {
                    notificationInstance.close(); // 关闭通知
                    document.removeEventListener('click', handler); // 移除监听
                    toActivity();
                }
            });
        };
        // 绑定微信
        const onBindWx = () => {
            nextTick(() => {
                proxy.$refs.bindWxDialog.openWxQrDialog()
            })
        }
        const toBack = () => {
            if (window.history.length > 1) {
                router.go(-1)
            } else {
                // ElMessageBox.confirm('确定要关闭当前页面吗？', '关闭', {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning'
                // }).then(() => {
                    window.close()
                // }).catch(() => {
                //     // 用户取消关闭
                // })
            }
        }
        // 退出
        const logout = () => {
            // @ts-ignore
            store.dispatch(UserActionTypes.ACTION_LOGOUT)
            router.push(`/login`)
            ElNotification.closeAll() // 关闭所有通知
            //清除viewedExpresses的localStorage
            localStorage.removeItem('viewedExpresses')
            // router.push(`/login?redirect=${route.fullPath}`)
        }

        // 跳转至修改密码页
        const jumpToEditPassword = () => {
            router.push('/my/edit-password')
        }

        // 获取菜单提醒数据
        const getMenuWarning = async () => {
            const {code, data, msg} = await getMenuWarningApi() as any
            if (code == 200) {
                store.commit(UserMutationTypes.SET_MENU_WARNING, data)
            }
        }
        getMenuWarning() // 先执行一次再进行轮循

        // 定时获取菜单提醒数据
        let menuWarningTimer = setInterval(() => {
            getMenuWarning()
        }, 1000 * 60 * 3)

        // 销毁定时器
        onBeforeUnmount(() => {
            clearInterval(menuWarningTimer)
            // @ts-ignore
            menuWarningTimer = null
            clearInterval(InstationMsgWarnTimer)
            InstationMsgWarnTimer = null
            stopWatch();
        })
        
        // 监听是否有新订单，进行语音播报
        const listenSpeech = () => {
            getUnResolveOrder().then((res:any) => {
                const { code, data, msg } = res
                if (code == 200 && data.msg) {
                    turnonSpeech(data.msg)
                }
            })
        }

        // 监听是否有新工单，进行语音播报
        const listenWorkorder = () => {
            getUnResolveWorkorderApi().then((res:any) => {
                const { code, data, msg } = res
                if (code == 200 && data.msg) {
                    turnonSpeech(data.msg)
                }
            })
        }

        // 监听是否有新工单审核，进行语音播报
        const listenWorkorderCheck = () => {
            getWorkorderCheckStatusApi().then((res:any) => {
                const { code, data, msg } = res
                if (code == 200 && data.msg) {
                    turnonSpeech(data.msg)
                }
            })
        }
        // 标记是否已经弹出过
        const hasShownExpressDialog = ref(false);
        const expressMsgDialog = () => {
            const viewedExpresses= new Set(JSON.parse(localStorage.getItem('viewedExpresses') || '[]'));
            const filteredMsgs = expressMsg.filter((item: any) => !viewedExpresses.has(item.express_no));
            
            if (filteredMsgs.length === 0) return;

            const showCount = 2; // 默认显示2条
            let isExpanded = false;

            let notificationContent = `
                <h4 style="margin-bottom:10px">
                    <i class="iconfont icon-horn" 
                        style="margin-right:8px; font-size: 28px; color: #ffb538; vertical-align: middle;"></i>
                    物流存在异常 共${filteredMsgs.length}条
                </h4>
                <div class="notification-items" style="max-height: 300px;width:250px;overflow-y: auto;">
                    ${filteredMsgs
                        .slice(0, showCount)
                        .map(item => `
                            <div class="notification-item">
                                <p>订单号：${item.order_no}</p>
                                <p>物流单号：${item.express_no}</p>
                                <div class="notification-link"
                                    style="color: #409EFF; text-align: right; cursor: pointer;" 
                                    data-order-id="${item.order_id}" 
                                    data-order-no="${item.order_no}">
                                    去处理 >>
                                </div>
                            </div>
                        `)
                        .join('')}
                </div>
                ${filteredMsgs.length > showCount ?
                `<div class="expand-toggle" 
                    style="color: #F56C6C; text-align: center; cursor: pointer; margin-top: 10px;">
                    展开更多 >>
                </div>`: ''}
            `;

            ElNotification({
                message: `<div class="notification-content express-notification">${notificationContent}</div>`,
                duration: 0,
                dangerouslyUseHTMLString: true,
                offset: 0,
            });

            // **事件委托**
            document.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;

                // **点击订单跳转**
                if (target.classList.contains('notification-link')) {
                    const orderId = target.dataset.orderId;
                    const orderNo = target.dataset.orderNo;

                    if (orderId && orderNo) {
                        ElNotification.closeAll();
                        //viewedExpresses.add(orderNo);
                        // localStorage.setItem('viewedExpresses', JSON.stringify(Array.from(viewedExpresses)));
                        router.push(`/merchant-admin/order-edit?order_id=${orderId}`);
                    }
                }

                // **点击“展开更多”**
                if (target.classList.contains('expand-toggle')) {
                    const notificationContent = target.closest('.notification-content') as HTMLElement;
                    if (!notificationContent) return;

                    const notificationItems = notificationContent.querySelector('.notification-items');

                    if (!isExpanded) {
                        // **展开所有订单**
                        notificationItems!.innerHTML = filteredMsgs
                            .map(item => `
                                <div class="notification-item">
                                    <p>订单号：${item.order_no}</p>
                                    <p>物流单号：${item.express_no}</p>
                                    <div class="notification-link"
                                        style="color: #409EFF; text-align: right; cursor: pointer;" 
                                        data-order-id="${item.order_id}" 
                                        data-order-no="${item.order_no}">
                                        去处理 >>
                                    </div>
                                </div>
                            `)
                            .join('');

                        target.innerHTML = "收起 <<";
                        isExpanded = true;
                    } else {
                        // **收起**
                        notificationItems!.innerHTML = filteredMsgs
                            .slice(0, showCount)
                            .map(item => `
                                <div class="notification-item">
                                    <p>订单号：${item.order_no}</p>
                                    <p>物流单号：${item.express_no}</p>
                                    <div class="notification-link"
                                        style="color: #409EFF; text-align: right; cursor: pointer;" 
                                        data-order-id="${item.order_id}" 
                                        data-order-no="${item.order_no}">
                                        去处理 >>
                                    </div>
                                </div>
                            `)
                            .join('');

                        target.innerHTML = "展开更多 >>";
                        isExpanded = false;
                    }
                }
            });
        };
        const toOrder = () => {
            router.push('/merchant-admin/order-edit?order_id=' + expressMsg.order_id);
        }
        const toActivity = () => {
            router.push('/merchant-admin/activity-list')
        }
        // 商家发起活动提醒
        let merchantInitActivityElNotification:any = null
        const merchantInitActivity = (message) => {
            merchantInitActivityElNotification =  ElNotification({
                customClass: 'custom-notification',
                message: `
                    <div class="notification-content promotion-notification">
                        <h4 style="padding-bottom:10px">
                            <i class="iconfont icon-horn" style="margin-right:8px; font-size: 28px; color: #ffb538; vertical-align: middle;"></i>
                            商家发起活动
                        </h4>
                        <div style="max-height:150px;overflow-y:auto;">
                            ${message.map((item, index) => `<p style="margin-bottom:5px"><b>${index+1}.</b> ${item} </p>`).join("")}
                        </div>
                        <div class="notification-link" style="color:#409EFF;text-align:right;cursor:pointer;">去审核 >></div>
                    </div>
                `,
                onClick: () => {
                    router.push('/check/activity-list')
                    sessionStorage.removeItem('merchant_new_promotion_msg');
                    merchantInitActivityElNotification?.close()
                },
                onClose: () => {
                    sessionStorage.removeItem('merchant_new_promotion_msg');
                },
                duration: 0,
                zIndex: 1500,
                dangerouslyUseHTMLString: true,
            });
        }
        // 活动 2 天内即将到期提醒
        const activityExpire = (message) => {
            const activityExpireElNotification =  ElNotification({
                customClass: 'custom-notification',
                message: `
                    <div class="notification-content promotion-notification">
                        <h4 style="padding-bottom:10px">
                            <i class="iconfont icon-horn" style="margin-right:8px; font-size: 28px; color: #ffb538; vertical-align: middle;"></i>
                            活动即将到期
                        </h4>
                        <div style="max-height:150px;overflow-y:auto;">
                            ${message.map((item, index) => `<p style="margin-bottom:5px"><b>${index+1}.</b> ${item} </p>`).join("")}
                        </div>
                        <div class="notification-link" style="color:#409EFF;text-align:right;cursor:pointer;">去查看 >></div>
                    </div>
                `,
                onClick: () => {
                    router.push('/activity/promotion/list')
                    sessionStorage.removeItem('merchant_expire_promotion_msg');
                    activityExpireElNotification.close()
                },
                onClose: () => {
                    sessionStorage.removeItem('merchant_expire_promotion_msg');
                },
                duration: 0,
                zIndex: 1500,
                dangerouslyUseHTMLString: true,
                offset: merchantInitActivityElNotification ? 250 : 0
            });
        }
        onMounted(() => {
            if(sessionStorage.getItem('merchant_new_promotion_msg')) { // 商家有发起新活动提醒运营
                merchantInitActivity(JSON.parse(sessionStorage.getItem('merchant_new_promotion_msg') as string))
            }
            if(sessionStorage.getItem('merchant_expire_promotion_msg')) { // 有活动要将在 2 天内结束提醒运营
                activityExpire(JSON.parse(sessionStorage.getItem('merchant_expire_promotion_msg') as string))
            }
            // 仅针对商户
            // @ts-ignore
            if (store.state.user.userInfo.user_type == 2) {
                // 判断是否需要绑定手机号
                if (!store.state.user.userInfo.phone) {
                    proxy.$refs.bindPhoneDialog.openDialog()
                }

                // 判断是否有新订单进行语音播报
                listenSpeech()
                setInterval(() => {
                    listenSpeech()
                }, 1000 * 60)

                // 判断是否有新工单进行语音播报
                setTimeout(() => {
                    listenWorkorder()
                }, 5);

                setTimeout(() => {
                    listenWorkorderCheck()
                }, 10);
                
                setInterval(() => {
                    listenWorkorder()
                }, 1000 * 35)
                setInterval(() => {
                    listenWorkorder()
                    listenWorkorderCheck()
                }, 1000 * 55)
            }
        })
        const getInstationMsgWarn = async () => {
            const {code, data} = await getInstationMsgWarnApi() as any
            if (code == 200) {
                state.NoticeList = data;   
            }
} 
         // 定时获取滚动数据
        let InstationMsgWarnTimer = setInterval(() => {
            getInstationMsgWarn()
        }, 1000 * 60)
        getInstationMsgWarn()
        //监听expressMsg有值则弹出
        watch(() => router.currentRoute.value.path, (newVal, oldValue) => {
            if (newVal) {
                const viewedExpresses = JSON.parse(localStorage.getItem('viewedExpresses') || '[]');
                const hasUnviewedExpresses = expressMsg.some((item: any) => !viewedExpresses.includes(item.express_no));

                // 检查页面上是否已经有通知
                const notificationExists = document.querySelector('.el-notification');

                // 确保通知只会弹出一次
                if (hasUnviewedExpresses && !notificationExists && !hasShownExpressDialog.value) {
                    expressMsgDialog(); // 弹出通知
                    hasShownExpressDialog.value = true; // 标记为已显示通知
                }

                // 切换到 /merchant-admin/order-edit 页面时，关闭所有通知
                if (newVal === '/merchant-admin/order-edit') {
                    ElNotification.closeAll(); // 清除所有通知
                    hasShownExpressDialog.value = false; // 复位标记
                }
            }
        }, { immediate: true });
        const handleHornClick = ()=>{
            proxy.$refs.noticeDialog.openDialog()
        }
        const clickRowNotice = (item:any) => {
            if (item.type === 2) {
                router.push({path: '/notice/training-list',query: {file_type: item.course_type === 1 ? 1 : 2}}) 
            } else {
            router.push({path: '/notice/notice-list',query: {title: item.title, desc: item.desc,rule_id:item.rule_id,notice:true}})
            }  
        }  
        return { sidebar, userInfo, UserType, logout, jumpToEditPassword, onBindWx, turnonSpeech, ...toRefs(state),toBack,expressMsg,expressMsgDialog,hasShownExpressDialog,dialogBeforeClose,promotionDialog,toActivity,promotionMsg,handleHornClick,warningLength,getInstationMsgWarn,clickRowNotice, searchDialogVisible, searchQuery, searchResults, openSearchDialog, handleSearch, handleSearchResultClick,onSearchDialogOpen}
    },
})
